export {
  PhotoCaptureHUDElementsAddDamage2ndShot,
  type PhotoCaptureHUDElementsAddDamage2ndShotProps,
} from './PhotoCaptureHUDElementsAddDamage2ndShot';
